import React from "react";
import RMSLoader from "./RMSLoader";

const KendoLoadingPanel = () => {
  return (
    <div className="border-none z-100 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
      <RMSLoader height={70} width={70} />
    </div>
  );
};

export default KendoLoadingPanel;
